/// <amd-module name="Agile/Directory/Redux/UIState/DirectoryUIStateReducer" />
import { DirectoryGroupKeys } from "Agile/Directory/DirectoryConstants";
import { IDirectoryUIState } from "Agile/Directory/DirectoryContracts";
import { DirectoryActions, DirectoryActionTypes } from "Agile/Directory/Redux/DirectoryActions";
import produce from "immer";

/**
 * Reducer which handles the UI state
 */
export function directoryUIStateReducer(state: IDirectoryUIState, action: DirectoryActions): IDirectoryUIState {
    return produce(state || getDefaultState(), draft => {
        switch (action.type) {
            case DirectoryActionTypes.InitialDataLoadFailed: {
                draft.exceptionInfo = action.payload;
                break;
            }

            case DirectoryActionTypes.BeginLoadAllData: {
                draft.isAllSectionLoading = true;
                break;
            }

            case DirectoryActionTypes.LoadAllDataSucceeded: {
                draft.isAllSectionLoading = false;
                draft.isAllSectionPopulated = true;
                break;
            }

            case DirectoryActionTypes.LoadAllDataFailed: {
                draft.isAllSectionLoading = false;
                draft.exceptionInfo = action.payload;
                break;
            }

            case DirectoryActionTypes.RowGroupCollapsedInitialized: {
                const initialMapping = { ...action.payload };
                // ignore the saved all state
                delete initialMapping[DirectoryGroupKeys.AllGroupKey];

                draft.rowGroupCollapsedMap = {
                    ...draft.rowGroupCollapsedMap,
                    ...initialMapping
                };
                break;
            }

            case DirectoryActionTypes.RowGroupToggled: {
                const { collapsed, rowGroupKey } = action.payload;
                draft.rowGroupCollapsedMap[rowGroupKey] = collapsed;
                break;
            }

            case DirectoryActionTypes.ToggleFilter: {
                draft.isFilterBarVisible = !draft.isFilterBarVisible;
                break;
            }
        }
    });
}

export function getDefaultState(): IDirectoryUIState {
    return {
        isFilterBarVisible: false,
        isAllSectionLoading: false,
        isAllSectionPopulated: false,
        rowGroupCollapsedMap: {
            [DirectoryGroupKeys.AllGroupKey]: true
        }
    };
}
